import AuditLogs from "./audit/pages/AuditLogs";
import Dashboard from "./dashboard/pages/Dashboard";
import Projects from "./projects/pages/Projects";
import Sources from "./sources/pages/Sources";
import Support from "./support/pages/Support";
import SupportTicketDetail from "./support/pages/SupportTicketDetail";
import Users from "./users/pages/Users";

const adminRoutes = [
  {
    path: "/admin/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/admin/users",
    element: <Users />,
  },
  {
    path: "/admin/projects",
    element: <Projects />,
  },
  {
    path: "/admin/sources",
    element: <Sources />,
  },
  {
    path: "/admin/support",
    element: <Support />,
  },
  {
    path: "/admin/support/:ticketId",
    element: <SupportTicketDetail />,
  },
  {
    path: "/admin/audit-logs",
    element: <AuditLogs />,
  },
];

export default adminRoutes;
